<div class="container" [ngClass]="{'greyBg': isCamera}">
  <div class="scan-area" [attr.aria-label]="helpTxt">
    <zxing-scanner id="videoElement" (camerasFound)="cameraLoaded($event, true) "
                   (torchCompatible)="checkFlash($event)"
                   [torch]="torch"
                   (camerasNotFound)="cameraLoaded($event, false) "
                   (scanSuccess)="scanComplete($event, true) ">
    </zxing-scanner>
    <div class="camera-place-holder " *ngIf="!isCamera">
            <span class="help-text" aria-label="help text">
          Savvas Bounce Pages uses the device camera to scan page and show relevant additional content
          </span>
    </div>
    <div class="help-txt video-help-txt"
         tabindex="0"
         role="alert"
         aria-atomic="true"
         aria-live="assertive" *ngIf="isCamera">{{helpTxt}}</div>
  </div>
  <div class="button-wrapper" *ngIf="isCamera && !scanProgress" [ngClass]="{'stage-2': showSubtitle}">
    <div *ngIf="!showSubtitle" class="button-container capture">
      <div></div>
      <button #cameraBtn class="camera-btn" (click)="capture()" aria-label="Camera button"></button>
      <button *ngIf="isFlash" class="flash" (click)="toggleFlash()" [attr.aria-label]="flashHelpTxt"></button>
      <div *ngIf="!isFlash"></div>
    </div>
    <div *ngIf="showSubtitle" class="button-container multi">
      <button class="back" aria-label="Go Back" (click)="toggleScan(true)">&lsaquo; Back</button>
      <button class="take-another-pic"
              role="button"
              aria-label="Take another Picture"
              (click)="toggleScan(true)">Take Another Picture</button>
      <div class="flash-wrapper">
        <div class="flash" *ngIf="isFlash"
             [attr.aria-label]="flashHelpTxt"
             (click)="toggleFlash()"></div>
      </div>
      <div *ngIf="!isFlash"></div>
    </div>
    <div class="copyright" role="region" aria-label="copyright info">
            Copyright &copy; 2020 Savvas Learning Company LLC. All Rights Reserved.
            <a href="https://savvasrealize.com/userAgreement.html" target="_blank">User Agreement</a>
            | <a href="https://savvasrealize.com/privacy/corporate/privacy/learning-services-privacy-policy.html" target="_blank">Privacy Policy</a>
            | <a href="https://media.pk12ls.com/curriculum/credits/index.html" target="_blank">Credits</a>
    </div>
  </div>
</div>
<app-camera-corners *ngIf="isCamera && !scanProgress"></app-camera-corners>
<div class="subtitle-wrapper" *ngIf="showSubtitle">
  <button class="subtitle-btn" *ngFor="let bookDetail of bookDetails"
          aria-label="Bounce Pages"
          (click)="navigateToURL(bookDetail[0])">
<!--    <span *ngIf="bookDetail[0].booktitle.length > 0">{{bookDetail[0].booktitle}}</span>-->
<!--    <span *ngIf="bookDetail[0].asset[0].desc.length === 0">({{bookDetail[0].program}})</span>-->
<!--    <span *ngIf="bookDetail[0].asset[0].desc.length > 0">({{bookDetail[0].asset[0].desc}})</span>-->
  </button>
</div>
<canvas #canvas></canvas>
